import CustomerSearchValue   from "../../../domain/customer/criteria/CustomerSearchValue";
import CustomerSortType      from "../../../domain/customer/criteria/CustomerSortType";
import CustomerId            from "../../../domain/customer/CustomerId";
import CustomerRepository    from "../../../domain/customer/CustomerRepository";
import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import CurrentPage           from "../../../domain/fundamentals/pagination/CurrentPage";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import CustomerDataSource    from "../../../infrastructure/datasource/customer/CustomerDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import RouterDispatcher      from "../../../infrastructure/redux/router/RouterDispatcher";
import GetCustomers          from "./GetCustomers";

class DeleteCustomer {
  constructor(
    private readonly dispatch,
    private readonly customerRepository: CustomerRepository = new CustomerDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
    private readonly routerDispatcher: RouterDispatcher = new RouterDispatcher(dispatch),
    private readonly getCustomers: GetCustomers = new GetCustomers(dispatch),
  ) {}

  public async execute(customerId: CustomerId, current: CurrentPage, search: CustomerSearchValue, sortType: CustomerSortType) {
    this.fetchStatusRepository.start();
    try {
      await this.customerRepository.delete(customerId);
      await this.getCustomers.execute(current, search, sortType);
      this.routerDispatcher.customers();
      this.notifyRepository.deleteSuccess();
    } catch (e) {
      this.notifyRepository.deleteFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default DeleteCustomer;
